<!--
  @Description: 英文版月报
  @Author: wang.y 
  @Date: 2025-11-19 
-->
<template>
  <div class="index">
    <div :class="{header: true, on: isOpen}" v-cloak>
      <img :src="customReportDto.logoPath | logo_show">
      <span @click="chapter_list_show = !chapter_list_show">
        No.{{currentChapterDto.num}} {{currentChapterDto.enTitle}}<i class="iconfont">
          <template v-if="chapter_list_show">&#xe63b;</template>
          <template v-else>&#xe648;</template>
        </i>
      </span>
    </div>
    <div class="chapter-sel">
      <ul v-if="chapter_list_show">
        <li v-for="item in chapterDtoList" :key="item.id" :class="{active: currentChapterId == item.id}" @click="haddleChangeChapter(item.id)">
          <i class="iconfont">&#xe628;</i>
          <span>No.{{item.num}} {{item.enTitle}}</span>
        </li>
      </ul>
    </div>
    <div class="chapter-meng" v-if="chapter_list_show" @click="chapter_list_show = !chapter_list_show"></div>
    <div :class="{plane: true, on: isOpen}">
      <div class="banner">
        <div class="tle">
          <div style="height: 0.8rem;" v-if="$route.query.name == 'santen'"></div>
          <img :src="customReportDto.logoPath | logo_show" class="logo-img" v-else>
          <p>{{customReportDto.enTitle}}</p>
        </div>
        <img :src="static_img_url + 'pic/newsletter/santen-bg-m.png'" v-if="$route.query.name == 'santen'"/>
        <img :src="static_img_url + 'pic/newsletter/common-bg-m.png'" v-else/>
      </div>
      <div class="search-container">
        <div class="search-ipt">
          <i class="iconfont search-icon">&#xe6d7;</i>
          <Input v-model="searchKeyword" @on-enter="handleSearch" placeholder="Search title, content, entity, policy, indication" />
          <Button @click="handleSearch">Search</Button>
        </div>
      </div>

      <div class="content">
        <div class="numbers clear">
          <div v-for="item,index in moduleList" :key="index" @click="haddleModelSlider(item.id)" :class="{'blue': item.id == '13'}">
            <span>{{item.enName}}</span>
            <i class="iconfont number-icon">&#xe647;</i>
          </div>
        </div>
        <div class="summary">
          <p class="tle">Current Summary</p>
          <p class="tle-line"></p>
          <div v-html="currentChapterDto.enSummary"></div>
        </div>
        <div class="temps">
          <div class="temp" v-for="item,index in moduleList" :key="index" :id="'tempLi' + item.id">
            <div class="temp-content">
              <div class="tle">
                <img :src="static_img_url + 'mobile/pic/briefReport/icon_l.png'">
                <span>{{item.enName}}</span>
                <img :src="static_img_url + 'mobile/pic/briefReport/icon_r.png'">
              </div>
              <ul class="content-list" v-if="moduleContents[item.id].length">
                <li v-for="secItem,topicIndex in moduleContents[item.id]" :key="topicIndex" v-show="topicIndex < 10 || showAll[item.id]">
                  <div class="topic" v-if="secItem.contentType === 0">
                    <div class="title">
                      <img :src="static_img_url + 'mobile/pic/briefReport/slash.png'" class="slash">
                      <a :href="secItem.srcUrl" target="_blank">{{secItem.enTitle}}</a>
                    </div>
                    <div class="desc" v-html="secItem.enContent"></div>
                  </div>
                  <div class="report" v-if="secItem.contentType === 2">
                    <a class="image" :href="secItem.srcUrl" target="_blank">
                      <img :src="secItem.logoPath | logo_show" />
                    </a>
                    <div class="card">
                      <div class="card-top">
                        <a :href="secItem.srcUrl" target="_blank" class="title">{{secItem.enTitle}}</a>
                        <!-- <div class="desc" v-html="secItem.enContent"></div> -->
                      </div>
                      <div class="card-btm">
                        <span v-if="secItem.srcAuthor"><i class="iconfont">&#xe645;</i>来源：{{secItem.srcAuthor}}</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="temp-bottom" v-if="moduleContents[item.id].length > 10">
                <span class="more-btn" @click="showAllList(item.id)">
                  {{!showAll[item.id] ? 'Expand' : 'Hide' }} All
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <BackTop right="10"></BackTop>
  </div>
</template>
<script>
import { addPuv, AchapterInfo, AchapterModuleContentList, AchapterModuleList } from '@/service'
import filter from 'js/filter'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  components: {},
  created() {
    if (this.$route.query.uid && this.$route.query.name) {
      this.getDetail()
    } else {
      this.$Message.error('Invalid URL parameter!')
      this.$router.push({ path: '/no' })
    }
  },
  mounted() {},
  beforeDestroy() {},
  data() {
    return {
      isOpen: false,
      chapter_list_show: false,
      
      filter,
      loading: true,

      chapterDtoList: [],
      customReportDto: {},
      moduleList: [],
      moduleContents: {},

      chapterParams: {
        chapterIds: [],
        keyword: '',
        moduleIds: [],
        startTime: '',
        endTime: '',
        getCount: false,
        page: 1,
        size: 99999,
        topCreateTime: null,
      },

      currentModuleId: '',

      currentChapterId: '',
      currentChapterDto: {},

      searchKeyword: '',
      showAll: {},

      tempTopArr: [],
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      static_img_url: (state) => state.static_img_url,
      img_req_url: (state) => state.img_req_url,
    }),
    reportPath() {
      return function (path) {
        const protocol = window.location.protocol
        return `${protocol}//static-cdn.vcbeat.top/pdf/web/viewer-d8.html?file=${this.img_req_url}${path}`
      }
    },
  },
  methods: {
    /**
     * 获取月报英文基本信息及期刊
     */
    async getDetail() {
      let res = await AchapterInfo(
        {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
        },
        (error) => this.$Message.error('Request Error!')
      )
      if (res.code === 0) {
        if (res.data.customReportDtoList.length) {
          this.$set(this.$data, 'customReportDto', res.data.customReportDtoList[0])
        }
        if (res.data.chapterDtoList.length) {
          this.$set(this.$data, 'chapterDtoList', res.data.chapterDtoList)

          if (this.$route.query.chapter) {
            const targetChapter = res.data.chapterDtoList.find(
              (item) => item.id == this.$route.query.chapter
            )
            this.currentChapterDto = targetChapter || res.data.chapterDtoList[0]
          } else {
            this.currentChapterDto = res.data.chapterDtoList[0]
          }
          this.currentChapterId = this.currentChapterDto.id
          this.getModuleList()
        }
        this.getAddPuv()
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    /**
     * 统计
     */
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.customReportDto.id,
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('Request Error!'))
    },
    /**
     * 获取月报英文期刊的模块列表
     */
    async getModuleList() {
      let res = await AchapterModuleList(
        {
          chapterIds: [this.currentChapterId],
        },
        (error) => this.$Message.error('Request Error!')
      )
      if (res.code === 0) {
        this.$set(this.$data, 'moduleList', res.data.moduleList)
        this.moduleList.forEach((item) => {
          this.$set(this.moduleContents, item.id, [])
          this.$set(this.showAll, item.id, false)
        })
        this.chapterParams.chapterIds = [this.currentChapterId]
        this.getModuleContentList()
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    /**
     * 获取月报英文期刊的模块内容列表
     */
    async getModuleContentList() {
      let res = await AchapterModuleContentList(this.chapterParams, (error) =>
        this.$Message.error('Request Error!')
      )
      this.loading = false
      if (res.code === 0) {
        res.data.contentDtos.forEach((item) => {
          this.moduleContents[item.moduleId].push(item)
        })
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    showAllList(moduleId) {
      this.showAll[moduleId] = !this.showAll[moduleId]
      this.$forceUpdate()
    },
    /**
     * 切换期刊
     */
    haddleChangeChapter(value) {
      const index = this.chapterDtoList.findIndex((a) => a.id == value)
      this.currentChapterDto = this.chapterDtoList[index]
      this.currentChapterId = value
      this.getModuleList()
      this.chapter_list_show = !this.chapter_list_show
    },
    /**
     * 导航点击事件
     * item 点击的对象
     */
    haddleModelSlider(moduleId) {
      let targetTop
      if (moduleId === '') {
        targetTop = 0
      } else {
        targetTop = $('#tempLi' + moduleId).offset().top - 68
      }
      $('html, body').animate({ scrollTop: targetTop }, 200)
    },
    handleSearch() {
      if (!this.searchKeyword) {
        this.$Message.error('Please enter search content!')
        return
      }
      const encodedKeyword = encodeURIComponent(this.searchKeyword)
      this.$router.push({
        name: 'MEnSearchNewsletter',
        query: { ...this.$route.query, ...{ keyword: encodedKeyword } },
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~mobile/styles/briefReport.stylus'
@import '~mobile/styles/newsletter.stylus'
ellipsisClamp(clamp)
  display -webkit-box
  overflow hidden
  text-overflow ellipsis
  word-break break-all
  -webkit-box-orient vertical
  -webkit-line-clamp clamp
.banner
  .tle
    font-size 0.46rem
    top calc(50% - 0.4rem)
    img
      height 0.8rem
      width auto
      display inline-block
    p
      margin-top 0.4rem
.search-container
  padding 0.3rem .3rem 0
  display flex
  justify-content center
  .search-ipt
    margin-top 0
</style>